import script from "./ForgotPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=f4d98250&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4d98250"]])

export default __exports__